/**
 * Central brand configuration.
 */

export const brand = {
  // App name shown in header, sidebar, and browser tab
  appName: 'Energieportal',

  // Short name for sidebar header
  shortName: 'WiSo',

  // Logo path (relativ zu /public)
  logo: '/logo.png',

  // Logo size in pixels
  logoSize: { width: 40, height: 40 },

  colors: {
    primary: '#216dab',    // WiSo Blau
    secondary: '#93c94f',  // WiSo Grün
    accent: '#3aa6e9',     // WiSo Hellblau
    shadow: '#C7E4FF',     // WiSo Shadow/Subtle
  },
} as const;

export const brandColors = {
  50:  '#F5FBFF',
  100: '#e0f0ff',
  200: '#C7E4FF',
  300: '#93cbf0',
  400: '#3aa6e9',
  500: '#216dab',
  600: '#1a5a8f',
  700: '#154872',
  800: '#0f3656',
  900: '#0a243a',
  950: '#05121d',
} as const;

export const sidebarColors = {
  background:       '#1a1a2e',
  headerBorder:     '#1e3a5f',
  brandText:        '#3aa6e9',
  linkText:         '#cbd5e1',
  linkHover:        '#C7E4FF',
  linkActiveBg:     '#C7E4FF',
  linkActiveBorder: '#216dab',
  footerBorder:     '#1e3a5f',
  avatarBg:         '#216dab',
  roleText:         '#A5C4DD',
  menuBg:           '#1e3a5f',
  menuHover:        '#2a4f7a',
} as const;
